import { getProductData, getProductSpecsToString, getProductTypeText, Part, PartProduct } from '@app/entities/Product';
import { useAppSelector } from '@app/redux/hooks';

interface ReturnUseDataPreparationFastOrder {
  productName: string;
  productSpecName?: string;
  productId: number;
  productRn: number;
  part: PartProduct | Part;
  price: number;
  quantity: number;
  allQuantity: number;
}

export const useDataPreparationFastOrder = (): ReturnUseDataPreparationFastOrder => {
  const { price, part, productName, id: productId, rn: productRn, actualQuantity, allQuantity, productSpecs } = useAppSelector(getProductData);

  return {
    part,
    price,
    productId,
    productName: getProductTypeText(part) + ' ' + productName,
    productSpecName: getProductSpecsToString(productSpecs, part),
    productRn,
    quantity: actualQuantity,
    allQuantity,
  };
};
